import React from "react";
import ColorSwatch from "./ColorSwatch";

const PaletteDisplay = ({
  title,
  colors,
  onColorClick,
  baseColor,
  visibleFields,
  colorBlindnessType,
  isDark,
  addColorToPalette,
  addColorToCustomPalette,
}) => {
  return (
    <div className="">
      {/*<h3 className="text-md font-medium mb-4">{title}</h3>*/}
      <div className="flex flex-wrap gap-2">
        {colors.map((color, index) => (
          <ColorSwatch
            key={index}
            color={color}
            number={index + 1}
            onClick={onColorClick}
            isBaseColor={color === baseColor}
            visibleFields={visibleFields}
            colorBlindnessType={colorBlindnessType}
            isDark={isDark}
            onAddToPalette={addColorToPalette}
            onAddToCustomPalette={addColorToCustomPalette}
          />
        ))}
      </div>
    </div>
  );
};

export default PaletteDisplay;
